import { createFileRoute } from '@tanstack/react-router';
import { validateSkillsSearch } from '../lib/skills-search.js';
import { SkillsRouteComponent } from './skills.js';

export const Route = createFileRoute('/$workspaceSlug/skills')({
  component: SkillsRouteComponent,
  validateSearch: validateSkillsSearch,
});
